﻿import React, { useState, useEffect } from 'react';
import { HplcDetectorType1 } from '../models/hplc-detector-type-1';
import { HplcDetectorType } from '../models/enums';
import { FieldUpdate } from '../models/field-update';
import { NumberBoxComponent } from './NumberBoxComponent';
import { ItemBasicInformation } from '../models/item-basic-information';
import { HplcBenchSheetDetectorSignal } from '../models/hplc-bench-sheet-detector-signal';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { CrudFunctions } from '../utilities/crud-functions';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    hplcBenchSheetDetectorId: string;
    isReadOnly?: boolean;
    onDetectorDeleted?: () => void;
}

export default function HplcInstrumentType1Component(props: Props) {
    const [detector, setDetector] =
        useState<HplcDetectorType1>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();
          
    useEffect(() => {
        getAllData();
    }, [props.hplcBenchSheetDetectorId]);

    key++;

    return (
        <div className="pw-form-section">
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                    <div className="pw-form-unit-label">Detector</div>
                    <div className="pw-readonly-label">{detector && detector.detectorType ?
                        detector.detectorType.name : 'NA'}</div>
                </div>

                {/*
                {detector && detector.detectorType &&
                    detector.detectorType.id === HplcDetectorType.VWD &&
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                            <label className="pw-form-unit-label">Signal A</label>
                            <NumberBoxComponent id="signalA" format="#" readOnly={props.isReadOnly}
                                fixedUnit={'nm'} onValueChanged={onSignalValueChanged}
                                value={detector && detector.signals &&
                                    detector.signals.length > 0 ? detector.signals[0].signalValue : undefined} />
                        </div>

                        <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                            <label className="pw-form-unit-label">Signal B</label>
                            <NumberBoxComponent id="signalB" format="#" readOnly={props.isReadOnly}
                                fixedUnit={'nm'} onValueChanged={onSignalValueChanged}
                                value={detector && detector.signals &&
                                    detector.signals.length > 1 ? detector.signals[1].signalValue : undefined} />
                        </div>
                    </div>
                }

                {detector && detector.detectorType &&
                    detector.detectorType.id === HplcDetectorType.ELSD &&
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                            <label className="pw-form-unit-label">Nebulizer</label>
                            <NumberBoxComponent id="nebulizer" format="#" readOnly={props.isReadOnly}
                                fixedUnit={'°C'} onValueChanged={onValueChanged}
                                value={detector ? detector.nebulizer : undefined} />
                        </div>

                        <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                            <label className="pw-form-unit-label">Evaporator</label>
                            <NumberBoxComponent id="evaporator" format="#" readOnly={props.isReadOnly}
                                fixedUnit={'°C'} onValueChanged={onValueChanged}
                                value={detector ? detector.evaporator : undefined} />
                        </div>

                        <div className="pw-form-unit pw-comp-20 pw-comp-row-align-bottom">
                            <label className="pw-form-unit-label">Gas Flow</label>
                            <NumberBoxComponent id="gasFlow" readOnly={props.isReadOnly}
                                fixedUnit={'SLM'} onValueChanged={onValueChanged}
                                value={detector ? detector.gasFlow : undefined} />
                        </div>
                    </div>
                }
                */}

                {detector && detector.detectorType &&
                    detector.detectorType.id === HplcDetectorType.RID &&
                    <div className="pw-form-unit pw-comp-15 pw-comp-row-align-bottom">
                        <label className="pw-form-unit-label">Temperature</label>
                        <NumberBoxComponent id="temperature" format="#" readOnly={props.isReadOnly}
                            fixedUnit={'°C'} onValueChanged={onValueChanged}
                            value={detector ? detector.temperature : undefined} />
                    </div>
                }

                <div className="delete-detector-container pw-margin-right-1">
                    <Button className="title-bar-button"
                        text="" icon="info" type="success"
                        hint="item information"
                        onClick={onShowInformationDialogClick} />
                    <Button className="pw-margin-left-05"
                        onClick={onDeleteDetectorClick}
                        text="" icon="trash" />
                </div>

                {itemBasicInformationDialogVisible &&
                    <DialogPopup visible={itemBasicInformationDialogVisible}
                        onHiding={hideItemBasicInformationDialog}
                        title="Item Basic Information"
                        width={'25rem'}
                        height={'21rem'}
                        dragEnabled={false}
                        resizeEnabled={false}>
                        <ItemBasicInformationDialog initInformation={itemBasicInformation}
                            onOkClick={hideItemBasicInformationDialog}
                            key={`IBI${key}`} />
                    </DialogPopup>
                }
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }
        </div>
    );

    async function onValueChanged(e: any) {
        if (!e.event)
            return;

        if (e.event.data && e.event.data.prop) {
            const caller = e.event.data.prop;

            setDetector({ ...detector, [caller]: e.value });

            const fieldUpdate: FieldUpdate = {
                entity: "HplcBenchSheetDetectors",
                field: e.event.data.prop,
                value: e.value,
                rowId: detector.hplcBenchSheetDetectorId
            };

            await updateDetectorField(fieldUpdate)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Detector Field");
                });
        }
    }

    async function onDeleteDetectorClick(e: any) {
        if (detector && props.hplcBenchSheetDetectorId) {
            await deleteDetector(props.hplcBenchSheetDetectorId)
                .then(() => {
                    //need to reload at parent
                    if (props.onDetectorDeleted)
                        props.onDetectorDeleted;
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Detector");
                });
        }
            }

    async function getDetector() {
        await CrudFunctions.getData(`benchsheets/hplcbenchsheetdetector/${props.hplcBenchSheetDetectorId}`)
            .then(data => {
                setDetector(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Detector");
            });
    }

    async function updateDetectorField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("benchsheets/hplcbenchsheetdetectorfield", fieldUpdate);
    }

    async function updateDetectorSignal(signal: HplcBenchSheetDetectorSignal) {
        return await CrudFunctions.putData("benchsheets/hplcdetectorsignal", signal);
    }

    async function deleteDetector(detectorId: string) {
        return await CrudFunctions.deleteData(`benchsheets/hplcbenchsheetdetector/${detectorId}`);
    }

    function onShowInformationDialogClick() {
        if (detector) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: detector.hplcBenchSheetDetectorId,
                createTimestamp: detector.createTimestamp,
                lastModifiedTimestamp: detector.modifyTimestamp,
                createUser: detector.createUser,
                modifyUser: detector.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    async function getAllData() {
        await getDetector();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

